import Vue from 'vue';

import ProductGridWithFilter from "./ProductGridWithFilter";
import SortTypeSelect from "./SortTypeSelect";

Vue.component('brku-product-grid-with-filter', ProductGridWithFilter);
Vue.component('brku-sort-type-select', SortTypeSelect);